import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import {
  STOP_CONSULTATION,
  STOP_CONSULTATION_LOCAL,
  HIDE_FINISHED_CONSULTATION,
} from '../actions/stopConsultation';

import { SET_VIDEO_LAYOUT } from '../actions/setVideoLayout';
import { SET_SELF_VIDEO_STATUS } from '../actions/setSelfVideoStatus';
import { SET_SELF_AUDIO_STATUS } from '../actions/setSelfAudioStatus';
import { START_CONSULTATION, SAVE_LOCAL_VIDEO } from '../actions/startConsultation';
import { SET_SOUND_LEVEL, SET_PREV_SOUND_LEVEL } from '../actions/videoConsultation';
import { CLEAR_CONVERSATION_PARAMS } from '../actions/_newConversationActions/checkActiveConversation';

const defaultState = {
  startConsultationRequestStatus: '',
  stopConsultationRequestStatus: '',
  outputSoundLevel: 50,
  prevOutputSoundLevel: null,
  switchedLayout: false,
  localVideo: null,
  selfAudioOff: false,
  selfVideoOff: false,
};

export default createReducer(defaultState, {
  [SET_PREV_SOUND_LEVEL]: (state, { payload: { value } }) => ({
    ...state,
    prevOutputSoundLevel: value,
  }),
  [SET_SOUND_LEVEL]: (state, { meta: { value } }) => ({
    ...state,
    outputSoundLevel: value,
  }),
  [SET_VIDEO_LAYOUT]: (state, { meta: { value } }) => ({
    ...state,
    switchedLayout: value,
  }),

  [SET_SELF_AUDIO_STATUS]: (state, { meta: { status } }) => ({
    ...state,
    selfAudioOff: status,
  }),
  [SET_SELF_VIDEO_STATUS]: (state, { meta: { status } }) => ({
    ...state,
    selfVideoOff: status,
  }),

  [START_CONSULTATION.success]: (state) => ({
    ...state,
    startConsultationRequestStatus: requestsStatuses.success,
  }),
  [START_CONSULTATION.failure]: (state) => ({
    ...state,
    status: '',
    startConsultationRequestStatus: requestsStatuses.failure,
  }),
  [START_CONSULTATION.pending]: (state) => ({
    ...state,
    errorCodes: [],
    status: '',
    startConsultationRequestStatus: requestsStatuses.pending,
  }),

  [SAVE_LOCAL_VIDEO]: (state, { payload: { localVideo } }) => ({
    ...state,
    localVideo,
  }),

  [STOP_CONSULTATION.pending]: (state) => ({
    ...state,
    stopConsultationRequestStatus: requestsStatuses.pending,
  }),

  [STOP_CONSULTATION.failure]: (state) => ({
    ...state,
    stopConsultationRequestStatus: requestsStatuses.failure,
  }),

  [STOP_CONSULTATION.success]: ({ outputSoundLevel, prevOutputSoundLevel }) => ({
    ...defaultState,
    outputSoundLevel,
    prevOutputSoundLevel,
    stopConsultationRequestStatus: requestsStatuses.success,
  }),

  [STOP_CONSULTATION_LOCAL]: () => ({
    ...defaultState,
    stopConsultationRequestStatus: requestsStatuses.success,
  }),

  [HIDE_FINISHED_CONSULTATION]: () => ({
    ...defaultState,
    stopConsultationRequestStatus: requestsStatuses.success,
  }),

  [CLEAR_CONVERSATION_PARAMS]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
